import React, { useState, useEffect } from 'react'
import ProgressCard from '../../Subcomponents/ProgressCard'
import cssClasses from './EventSettings.module.css'
import eventSettingsImg from '../../Assets/Images/Common/settings.svg'
import { Box } from '@mui/system'
import { TabContext } from '@mui/lab'
import TabsMenu from '../../Subcomponents/TabsMenu'
import TabPanel from '@mui/lab/TabPanel';
import Button from '../../Subcomponents/Button';
import ConfirmationAlert from '../../Subcomponents/ConfirmationAlert';
import CustomToggle from '../../Subcomponents/Toggle/CustomToggle';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
  getEvent,
  getLaunchDetails,
  getLaunchWise,
  startExpirePreselectCronJob,
  updateEvent,
} from '../../Services/Event';
import DateComponent from '../../Subcomponents/DateComponent';
import DropDown from '../../Subcomponents/DropDown';
import CustomInput from '../../Subcomponents/CustomInput';
import CustomAutoComplete from '../../Subcomponents/CustomAutoComplete';
import { getAllUsers } from '../../Services/Users';
import CustomRadio from '../../Subcomponents/CustomRadio';
import _, { cloneDeep, filter, isEqual, uniqBy } from 'lodash';
import { errorTost, successTost, offlineToast } from '../../Services/Toast';
import { getAllLaunchesByEvent, getAllLaunchesByEventForSettings, getLaunchTokenById, getTokenPreselectInfoById, insertIntoPreselectConfirmationConfig, updateIntoPreselectConfirmationConfig, updateLaunch } from '../../Services/Launch';
import { MuiColorInput } from 'mui-color-input';
import { makeStyles } from '@mui/styles';
import {
  getInventoryStatus,
  getProjectInventory,
} from '../../Services/Inventory';
import { getAllEventTokens } from '../../Services/EventTokens';
import { Checkbox, Tab, Tabs } from '@mui/material';
import { dismissLoader, presentLoader } from '../../Services/loader';
import { supabase } from '../../supabaseClient';
import PreselectConfig from '../../Components/PreselectConfig/PreselectConfig'
import { Network } from '@capacitor/network'

const useStyles = makeStyles((theme) => ({
  inputStyle: {
    fontSize: '1.4rem !important',
    '& input': {
      fontSize: '1.4rem !important',
      padding: '1.2rem !important',
    },
  },
}));

export default function EventSettings() {
  const classes = useStyles()
  const params = useParams()
  const navigate = useNavigate()
  const eventId = params.eventId
  const [searchParams, setSearchParams] = useSearchParams();
  const submenu = searchParams.get('submenu');
  const [event, setEvent] = useState(null)
  const [launch, setLaunch] = useState([]);
  const [parentEvent, setParentEvent] = useState(null)
  const [users, setUsers] = useState([])
  const [eventTokens, setEventTokens] = useState([])
  const [clickedIndex, setClickedIndex] = useState(0)
  const [launchData, setLaunchData] = useState([])
  const [launchWiseToken, setLaunchWiseToken] = useState([])
  const [tabs, setTab] = useState([]);
  const [eventSettings, setEventSettings] = useState({
    title: 'Settings',
    totalProgress: 5,
    timeline: [
      {
        text: 'Live Event Config',
        value: 'Live Event Config',
        isSelected: true,
      },
      {
        text: 'Live Inventory Display Config',
        value: 'Live Inventory Display Config',
        isSelected: false,
      },
      { text: 'Payment Config', value: 'Payment Config', isSelected: false },
      {
        text: 'Preselect Config',
        value: 'Preselect Config',
        isSelected: false,
      },
      {
        text: 'Site Visit Config',
        value: 'Site Visit Config',
        isSelected: false,
      },
    ],
    image: eventSettingsImg
  })
  const [openAlert, setOpenAlert] = useState(false)
  const [tokenSubTabs, setTokenSubTabs] = useState([])
  const [isBtnDisabled, setIsBtnDisabled] = useState(false)

  useEffect(() => {
    tabChanged('', submenu);
  }, [submenu]);
  useEffect(() => {
    getEvent(eventId)
      .then((resp) => {
        resp[0].settingsCompletedTabs = resp[0].settingsCompletedTabs
          ? resp[0].settingsCompletedTabs
          : [];
        setEventSettings((pre) => {
          pre.timeline.forEach((ele) => {
            if (resp[0].settingsCompletedTabs.includes(ele.text)) {
              ele.isCompleted = true;
            }
          });
          return { ...pre };
        });
        getLaunchWise(eventId)
          .then((launchResp) => {
            console.log('--->LAUNCHES----->', launchResp);
            launchUnitType(launchResp[0].launchId)
            setTab(
              launchResp.map((m, i) => {
                m.text = m.title;
                m.value = m.title;
                m.isSelected = Boolean(i === 0);
                return m;
              })
            );

            // setTabValue(launchResp[0].title)
          })
          .catch((err) => {
            console.error('getLaunchWise', err);
          });
        setEvent(resp[0]);
        let obj = cloneDeep(resp[0]);
        setParentEvent(obj);
        console.log(resp[0]);
      })
      .catch((err) => {
        console.error('getEvent', err);
      });
    getAllUsers('Latest First')
      .then((resp) => {
        console.log(resp);
        setUsers([...resp.data]);
      })
      .catch((err) => {
        console.error('getAllUsers', err);
      });
  }, []);
  useEffect(() => {
    const getAllLaunches = () => {
      presentLoader();
      getAllLaunchesByEvent(eventId)
        .then((resp) => {
          const payloadToken = [];
          setLaunchData(resp?.data);
          resp?.data?.map((val, index) => {

            getLaunchTokenById(val.launchId)
              .then((tokenResp) => {
                const finalPayload = _.uniqBy(tokenResp?.data, function (elem) { return [elem.launchId, elem.eventTokenId.eventTokenId].join(); });
                // const finalPayload = _.uniqBy(tokenResp?.data, e => e.eventTokenId);
                finalPayload.forEach((respVal) => {
                  getTokenPreselectInfoById(
                    respVal?.eventTokenId?.eventId,
                    respVal?.eventTokenId?.eventTokenId,
                    respVal?.launchId
                  )
                    .then((response) => {
                      respVal.preselectConfirmationConfig =
                        response?.data?.length > 0
                          ? response?.data[0]?.preselectConfirmationConfig
                          : {};
                      respVal.autoConfirmation =
                        response?.data?.length > 0
                          ? response?.data[0]?.autoConfirmation
                          : false;
                      respVal.showPreselectPrices =
                        response?.data?.length > 0
                          ? response.data[0]?.showPreselectPrices
                          : [];
                      respVal.priceDiscount =
                        response?.data?.length > 0
                          ? response?.data[0]?.priceDiscount
                          : 0;
                      respVal.isUpdate =
                        response?.data?.length > 0 ? true : false;
                      respVal.checkpoint = response?.data?.length > 0 ? response?.data[0]?.checkpoint : {}
                    })
                    .catch((err) => {
                      errorTost(err.message);
                      dismissLoader();
                    });
                });
                let count = 0
                if (finalPayload?.length > 0) {
                  setTokenSubTabs((pre) => {
                    const obj = {
                      text: val?.title,
                      value: val?.title,
                      isSelected: true,
                    };
                    return [...pre, obj];
                  });
                  ++count
                }
                payloadToken.push({ ...val, token: finalPayload });
                dismissLoader();
              })
              .catch((err) => {
                errorTost(err.message);
                dismissLoader();
              });
          });
          setLaunchWiseToken(payloadToken);
          dismissLoader();
        })
        .catch((err) => {
          errorTost(err.message);
          dismissLoader();
        });
    };
    getAllLaunches();
  }, []);

  useEffect(() => {
    if (launchWiseToken?.length > 0) {
      const payload = [];
      launchWiseToken.map((val) => {
        val?.token.map(resp => {
          payload.push(resp)
        })
      });


      if (payload.filter(response => response?.showPreselectPrices?.length === 0 ||
        !response?.preselectConfirmationConfig?.timer ||
        !response?.preselectConfirmationConfig?.endDateTime ||
        !response?.preselectConfirmationConfig?.startDateTime)?.length > 0) {
        setIsBtnDisabled(true);
      } else {
        setIsBtnDisabled(false);
      }
    }
  }, [launchWiseToken, eventSettings]);


  useEffect(
    () => {
      if (event) {
        if (eventSettings.timeline[1].isSelected === true) {
          let _eventDataResp = [];
          getEvent(eventId)
            .then((eventResp) => {
              console.log('event-Data', eventResp[0]);
              //   _eventDataResp = eventResp[0];
            })
            .catch((err) => {
              console.error('getEvent--', err);
            });
        }
        if (
          eventSettings.timeline[2].isSelected === true &&
          !event?.tokenPayment
        ) {
          presentLoader();
          getAllEventTokens(eventId)
            .then((resp) => {
              let arr = [];
              if (resp.data.length === 0) {
                dismissLoader();
              } else {
                resp.data.forEach((ele, index) => {
                  // arr.push({ token: ele.tokenId.name, paymentMethods: ['Razorpay'] })
                  arr.push({ token: ele.tokenId.name, paymentMethods: [] });
                  if (resp.data.length - 1 === index) {
                    setEvent((pre) => {
                      pre.tokenPayment = arr;
                      return { ...pre };
                    });
                    let newarr = cloneDeep(arr);
                    setParentEvent((pre) => {
                      pre.tokenPayment = newarr;
                      return { ...pre };
                    });
                    dismissLoader();
                  }
                });
              }
            })
            .catch((err) => {
              console.error('getAllEventTokens', err);
            });
        }
        if (eventSettings.timeline[3].isSelected === true) {
          supabase
            .from('EventTokens')
            .select('*,tokenId(*)')
            .eq('eventId', event.eventId)
            .eq('tokenId.isPreselect', true)
            .then((resp) => {
              if (resp.data.length > 0) {
                console.log(
                  resp.data.filter((e) => {
                    return e.tokenId;
                  })
                );
                setEventTokens(
                  resp.data.filter((e) => {
                    return e.tokenId;
                  })
                );
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    [eventSettings],
    event
  );


  function launchUnitType(launchId) {
    let _launchDataResp = [];
    getLaunchDetails(launchId).then((launchWiseResp) => {
      console.log('launchwise', launchWiseResp);
      _launchDataResp = launchWiseResp;
      getProjectInventory(launchWiseResp[0].projectId)
        .then((unitResp) => {
          const launchInventoryResp = uniqBy(
            unitResp,
            'unitId.inventoryTypeId.inventoryTypeId'
          );
          console.log('uniq-project-Config', launchInventoryResp);
          getInventoryStatus()
            .then((response) => {
              let arr = [];
              console.log('Inventory-Status', response);
              launchInventoryResp.forEach((ele, index) => {
                let obj = {
                  unitType: ele.unitId.inventoryTypeId.type,
                  display:
                    _launchDataResp[0]?.unitTypeDisplay?.find(
                      (f) => f.unitType === ele.unitId.inventoryTypeId.type
                    )?.display || false,
                  unitStatusDisplay: [],
                };
                response.forEach((elem, index) => {
                  // console.log("elm" , elem)
                  obj.unitStatusDisplay.push({
                    unitStatus: elem.status,
                    display: false,
                    color: '',
                    textColor: '',
                  });
                });
                obj.unitStatusDisplay = obj?.unitStatusDisplay.map((m) => ({
                  ...m,
                  display:
                    _launchDataResp[0]?.unitTypeDisplay
                      ?.find((f) => f.unitType === obj.unitType)
                      ?.unitStatusDisplay?.find(
                        (f) => f?.unitStatus === m?.unitStatus
                      )?.display || false,
                  color:
                    _launchDataResp[0]?.unitTypeDisplay
                      ?.find((f) => f.unitType === obj.unitType)
                      ?.unitStatusDisplay?.find(
                        (f) => f?.unitStatus === m?.unitStatus
                      )?.color || '',
                  textColor:
                    _launchDataResp[0]?.unitTypeDisplay
                      ?.find((f) => f.unitType === obj.unitType)
                      ?.unitStatusDisplay?.find(
                        (f) => f?.unitStatus === m?.unitStatus
                      )?.textColor || '',
                }));
                arr.push(obj);
              });

              console.log('arr', arr);
              console.log('event', _launchDataResp);
              let setData = _launchDataResp;
              console.log('setData', [...arr]);
              setData[0].unitTypeDisplay = [...arr];
              setLaunch([...setData]);
            })
            .catch((err) => {
              console.error('getInventoryStatus', err);
            });
        })
        .catch((err) => {
          console.log('getProjectInventory', err);
        });
    });
  }

  const tabChange = (newValue) => {
    let tabIndex = tabs.find((e) => e.value === newValue);
    launchUnitType(tabIndex.launchId)
  };

  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each.text}
        key={index}
        value={each.value}
        sx={[
          {
            fontFamily: 'Inter-Medium !important',
            fontStyle: 'normal !important',
            fontWeight: '500 !important',
            fontSize: '1.4rem !important',
            lineHeight: '2rem !important',
            textTransform: 'none !important',
          },
        ]}
      />
    );
  });

  function tabChanged(e, value) {
    let index = eventSettings.timeline.findIndex((e) => e.value === value)
    let previous = eventSettings.timeline.findIndex((e) => e.isSelected === true)
    if (eventSettings.timeline[0].isSelected === true) {
      if (!isEqual(parentEvent, event) && index !== 0) {
        setClickedIndex(index)
        setOpenAlert(true)
      } else {
        setEventSettings((pre) => { pre.timeline[previous].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
      }
    } else if (eventSettings.timeline[1].isSelected === true) {
      if (!isEqual(parentEvent, event) && index !== 1) {
        setClickedIndex(index)
        setOpenAlert(true)
      } else {
        setEventSettings((pre) => { pre.timeline[previous].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
      }
    } else if (eventSettings.timeline[2].isSelected === true) {
      if (!isEqual(parentEvent, event) && index !== 2) {
        setClickedIndex(index)
        setOpenAlert(true)
      } else {
        setEventSettings((pre) => { pre.timeline[previous].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
      }
    } else if (eventSettings.timeline[3].isSelected === true) {
      if (!isEqual(parentEvent, event) && index !== 3) {
        setClickedIndex(index)
        setOpenAlert(true)
      } else {
        setEventSettings((pre) => { pre.timeline[previous].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
      }
    } else if (eventSettings.timeline[4].isSelected === true) {
      if (!isEqual(parentEvent, event) && index !== 4) {
        setClickedIndex(index)
        setOpenAlert(true)
      } else {
        setEventSettings((pre) => { pre.timeline[previous].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
      }
    }
  }

  function nextStep() {
    let index = eventSettings.timeline.findIndex((e) => e.isSelected === true)
    if (index === 4 && event.eventSiteVisit && (!event.eventSiteVisitDateTime || event.eventSiteVisitDateTime === "")) {
      errorTost("Please set the dates for event site visit and then save");
    } else {
    if (index === 0) {
      setEvent((pre) => {
        if (!pre.settingsCompletedTabs.includes('Live Event Config')) {
          pre.settingsCompletedTabs.push('Live Event Config')
        }
        return { ...pre }
      })
      setParentEvent((pre) => {
        if (!pre.settingsCompletedTabs.includes('Live Event Config')) {
          pre.settingsCompletedTabs.push('Live Event Config')
        }
        return { ...pre }
      })
    } else if (index === 1) {
      setEvent((pre) => {
        if (!pre.settingsCompletedTabs.includes('Live Inventory Display Config')) {
          pre.settingsCompletedTabs.push('Live Inventory Display Config')
        }
        return { ...pre }
      })
      setParentEvent((pre) => {
        if (!pre.settingsCompletedTabs.includes('Live Inventory Display Config')) {
          pre.settingsCompletedTabs.push('Live Inventory Display Config')
        }
        return { ...pre }
      })
    } else if (index === 2) {
      setEvent((pre) => {
        if (!pre.settingsCompletedTabs.includes('Payment Config')) {
          pre.settingsCompletedTabs.push('Payment Config')
        }
        return { ...pre }
      })
      setParentEvent((pre) => {
        if (!pre.settingsCompletedTabs.includes('Payment Config')) {
          pre.settingsCompletedTabs.push('Payment Config')
        }
        return { ...pre }
      })
      } else if (index === 3) {
      setEvent((pre) => {
        if (!pre.settingsCompletedTabs.includes('Preselect Config')) {
          pre.settingsCompletedTabs.push('Preselect Config')
        }
        return { ...pre }
      })
      setParentEvent((pre) => {
        if (!pre.settingsCompletedTabs.includes('Preselect Config')) {
          pre.settingsCompletedTabs.push('Preselect Config')
        }
        return { ...pre }
      })
      } else {
        setEvent((pre) => {
          if (!pre.settingsCompletedTabs.includes('Site Visit Config')) {
            pre.settingsCompletedTabs.push('Site Visit Config')
          }
          return { ...pre }
        })
        setParentEvent((pre) => {
          if (!pre.settingsCompletedTabs.includes('Site Visit Config')) {
            pre.settingsCompletedTabs.push('Site Visit Config')
          }
          return { ...pre }
        })
    }
    presentLoader()
    if (!event.minOnlineAmt || event.minOnlineAmt === '') {
      event.minOnlineAmt = 0
    }

      Network.getStatus().then((status) => {
        if (status.connected) {
    updateLaunch(launch[0].launchId, { unitTypeDisplay: launch[0].unitTypeDisplay }).then((UpdateResp) => {
    }).catch((err) => {
      console.error("updateLaunch", err)
    })
    updateEvent(eventId, event)
      .then(async (resp) => {
        for (const ele of eventTokens) {
          await supabase
            .from('EventTokens')
            .update({ autoConfirmation: ele.autoConfirmation })
            .eq('eventTokenId', ele.eventTokenId);
        }
        if (index === 3) {
          handlePreselectTokenSave()
        } else {
          let arr = cloneDeep(event)
          setParentEvent(arr)
          successTost("Settings saved successfully")
          if (index !== 4) {
            setEventSettings((pre) => { pre.timeline[index + 1].isSelected = true; pre.timeline[index].isSelected = false; return { ...pre } })
          }
          if (index === 0) {
            searchParams.set('submenu', 'Live Inventory Display Config')
            setSearchParams(searchParams)
          } else if (index === 1) {
            searchParams.set('submenu', 'Payment Config')
            setSearchParams(searchParams)
          }
          dismissLoader()
        }
      }).catch((err) => {
        dismissLoader()
      })
        } else {
          offlineToast();
        }
      })
    }
  }

  const handlePreselectTokenSave = () => {
    const payload = [];
    launchWiseToken.map((val) => {
      val?.token.map(resp => {
        payload.push(resp)
      })
    });

    payload.map((val, index) => {
      const finalResp = {
        eventId: val?.eventTokenId?.eventId,
        eventTokenId: val?.eventTokenId?.eventTokenId,
        launchId: val?.launchId,
        showPreselectPrices: val?.showPreselectPrices,
        autoConfirmation: val?.autoConfirmation,
        checkpoint: val?.checkpoint,
        preselectConfirmationConfig: val?.preselectConfirmationConfig,
        priceDiscount: Number(val?.priceDiscount),
      };
      if (!val?.isUpdate) {

        insertIntoPreselectConfirmationConfig(finalResp)
          .then(() => {
            index === (payload?.length - 1) && successTost("Settings saved successfully");
            // ! call cron for preselect confirmation timer expire
            startExpirePreselectCronJob(eventId, val?.eventTokenId?.eventTokenId, val?.launchId);
            dismissLoader();
            navigate(`/home/Event/ConfigureEvent/${eventId}`);
          })
          .catch((err) => {
            errorTost(err.message);
            dismissLoader();
          });
      } else {
        updateIntoPreselectConfirmationConfig(finalResp)
          .then(() => {
            index === (payload?.length - 1) && successTost("Settings saved successfully");
            // ! call cron for preselect confirmation timer expire
            startExpirePreselectCronJob(eventId, val?.eventTokenId?.eventTokenId, val?.launchId);
            dismissLoader();
            navigate(`/home/Event/ConfigureEvent/${eventId}`);
          })
          .catch((err) => {
            errorTost(err.message);
            dismissLoader();
          });
      }
    });
  };

  function ModalResp(e) {
    setOpenAlert(false)
    if (e === 'confirmed') {
      let obj = cloneDeep(parentEvent)
      setEvent(obj)
      setEventSettings((pre) => { pre.timeline[eventSettings.timeline.findIndex((e) => e.isSelected === true)].isSelected = false; pre.timeline[clickedIndex].isSelected = true; return { ...pre } })
    } else {
      searchParams.set('submenu', eventSettings.timeline[eventSettings.timeline.findIndex((e) => e.isSelected === true)].value)
      setSearchParams(searchParams)
    }
  }

  return (
    <div className={cssClasses.mainContainer}>
      <div style={{ overflow: "auto" }}>
        <div className={cssClasses.header}>
          <div className={cssClasses.titleWrapper}>
            <div className={cssClasses.title}>
              <p>Settings</p>
            </div>
          </div>
        </div>
        <div className={cssClasses.content}>
          <div className={cssClasses.progressCardWrapper}>
            <div className={cssClasses.progressCard}>
              <ProgressCard
                defaultExpanded={false}
                image={eventSettings.image}
                totalProgress={eventSettings.totalProgress}
                currentProgress={event?.settingsCompletedTabs?.length}
                timeline={eventSettings.timeline}
                cardTitle={eventSettings.title}
              />
            </div>
          </div>
          <div className={cssClasses.tabsWrapper}>
            <Box
              className={cssClasses.TabsWrapper}
              style={{ height: "100%" }}
            >
              <TabContext
                value={eventSettings.timeline.find((f) => f.isSelected).value}
              >
                <TabsMenu
                  selectedColor={"#1570EF"}
                  selectedBackgroundColor={"#FFFFFF"}
                  stylesForTab={{
                    color: "#344054",
                    fontSize: "1.6rem",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "2.4rem",
                    padding: "0.8rem 1.2rem",
                    textTransform: "unset",
                    borderBottom: "1px solid #EAECF0",
                  }}
                  borderColor={"#1570EFs"}
                  stylesForWrapper={{
                    padding: "1.5rem 0",
                    background: "#FFFFFF",
                  }}
                  list={eventSettings.timeline}
                  value={eventSettings.timeline.find((f) => f.isSelected).value}
                  handleChange={(e, value) => {
                    searchParams.set('submenu', value);
                    setSearchParams(searchParams);
                  }}
                />
                <TabPanel
                  className={cssClasses.tabPanel}
                  value={'Live Event Config'}
                  index={0}
                >
                  <Box className={cssClasses.mainTabPanelWrapper}>
                    <div className={cssClasses.header}>
                      <p className={cssClasses.headerText}>Live Event Config</p>
                    </div>
                    <div className={cssClasses.content}>
                      <div className={cssClasses.labelToggleWrapper}>
                        <div style={{ flex: '25%' }}>
                          <p className={cssClasses.toggleLabel}>
                            Block Token Distribution:
                          </p>
                        </div>
                        <div style={{ flex: '75%' }}>
                          <CustomToggle
                            checked={event?.blockTokenDistribution}
                            setChecked={() => {
                              setEvent((pre) => {
                                pre.blockTokenDistribution =
                                  !pre.blockTokenDistribution;
                                return { ...pre };
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className={cssClasses.labelToggleWrapper}>
                        <div style={{ flex: '25%' }}>
                          <p className={cssClasses.toggleLabel}>
                            Show Unit Price:
                          </p>
                        </div>
                        <div
                          style={{
                            flex: '75%',
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            gap: '5rem',
                          }}
                        >
                          <CustomToggle
                            checked={event?.showUnitPrice}
                            setChecked={() => {
                              setEvent((pre) => {
                                if (pre.showUnitPrice === true) {
                                  pre.showUnitPriceDateTime = null;
                                  pre.showUnitPrice = false;
                                } else {
                                  pre.showUnitPrice = true;
                                }
                                return { ...pre };
                              });
                            }}
                          />
                          {event?.showUnitPrice && (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '2rem',
                              }}
                            >
                              <p className={cssClasses.toggleLabel}>
                                Date & Time:
                              </p>
                              <DateComponent
                                helperText={''}
                                value={event?.showUnitPriceDateTime}
                                minDate={new Date()}
                                onChangeDate={(e) => {
                                  setEvent((pre) => {
                                    pre.showUnitPriceDateTime = new Date(
                                      e
                                    ).getTime();
                                    return { ...pre };
                                  });
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className={cssClasses.labelToggleWrapper}>
                        <div style={{ flex: "25%" }}>
                          <p className={cssClasses.toggleLabel}>
                            Auto-release hold of units:
                          </p>
                        </div>
                        <div
                          style={{
                            flex: "75%",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: "5rem",
                          }}
                        >
                          <CustomToggle
                            checked={event?.autoReleaseUnits}
                            setChecked={() => {
                              setEvent((pre) => {
                                if (pre.autoReleaseUnits === true) {
                                  pre.autoReleaseUnitsTime = null;
                                  pre.autoReleaseUnits = false;
                                } else {
                                  pre.autoReleaseUnits = true;
                                }
                                return { ...pre };
                              });
                            }}
                          />
                          {event?.autoReleaseUnits && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "2rem",
                              }}
                            >
                              <p className={cssClasses.toggleLabel}>Time:</p>
                              <DropDown
                                list={[5, 10, 15, 30, 45, 60]}
                                selectedValue={event?.autoReleaseUnitsTime}
                                onChangeSelect={(e) => {
                                  setEvent((pre) => {
                                    pre.autoReleaseUnitsTime = e;
                                    return { ...pre };
                                  });
                                }}
                              />
                              <p className={cssClasses.toggleLabel}>mins</p>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className={cssClasses.labelToggleWrapper}>
                        <div style={{ flex: "25%" }}>
                          <p className={cssClasses.toggleLabel}>
                            Allow leads without token:
                          </p>
                        </div>
                        <div style={{ flex: "75%" }}>
                          <CustomToggle
                            checked={event?.allowLeadsWithoutToken}
                            setChecked={() => {
                              setEvent((pre) => {
                                pre.allowLeadsWithoutToken =
                                  !pre.allowLeadsWithoutToken;
                                return { ...pre };
                              });
                            }}
                          />
                        </div>
                      </div>
                      {/* <div className={cssClasses.labelToggleWrapper}>
                                                <div style={{ flex: "25%" }}>
                                                    <p className={cssClasses.toggleLabel}>Block online allotment:</p>
                                                </div>
                                                <div style={{ flex: "75%" }}>
                                                    <CustomToggle checked={event?.blockOnlineAllotment} setChecked={() => { setEvent((pre) => { pre.blockOnlineAllotment = !pre.blockOnlineAllotment; return { ...pre } }) }} />
                                                </div>
                                            </div> */}
                      <div className={cssClasses.labelToggleWrapper}>
                        <div style={{ flex: "25%" }}>
                          <p className={cssClasses.toggleLabel}>
                            Allow token buying in event:
                          </p>
                        </div>
                        <div style={{ flex: "75%" }}>
                          <CustomToggle
                            checked={event?.allowTokenBuyingInEvent}
                            setChecked={() => {
                              setEvent((pre) => {
                                pre.allowTokenBuyingInEvent =
                                  !pre.allowTokenBuyingInEvent;
                                return { ...pre };
                              });
                            }}
                          />
                        </div>
                      </div>
                      {/* <div className={cssClasses.labelToggleWrapper}>
                                                <div style={{ flex: "25%" }}>
                                                    <p className={cssClasses.toggleLabel}>Allow CP to hold unit:</p>
                                                </div>
                                                <div style={{ flex: "75%" }}>
                                                    <CustomToggle checked={event?.allowCpToHoldUnit} setChecked={() => { setEvent((pre) => { pre.allowCpToHoldUnit = !pre.allowCpToHoldUnit; return { ...pre } }) }} />
                                                </div>
                                            </div> */}
                      <div className={cssClasses.labelToggleWrapper}>
                        <div style={{ flex: "25%" }}>
                          <p className={cssClasses.toggleLabel}>
                            Adjust Token Amount:
                          </p>
                        </div>
                        <div style={{ flex: "75%" }}>
                          <CustomToggle
                            checked={event?.adjustTokenAmt}
                            setChecked={() => {
                              setEvent((pre) => {
                                pre.adjustTokenAmt = !pre.adjustTokenAmt;
                                return { ...pre };
                              });
                            }}
                          />
                        </div>
                      </div>
                      {/* <div className={cssClasses.labelToggleWrapper}>
                                                <div style={{ flex: "25%" }}>
                                                    <p className={cssClasses.toggleLabel}>Allow CP to assign a token:</p>
                                                </div>
                                                <div style={{ flex: "75%" }}>
                                                    <CustomToggle checked={event?.allowCpToAssignToken} setChecked={() => { setEvent((pre) => { pre.allowCpToAssignToken = !pre.allowCpToAssignToken; return { ...pre } }) }} />
                                                </div>
                                            </div> */}
                      {/* <div className={cssClasses.labelToggleWrapper}>
                                                <div style={{ flex: "25%" }}>
                                                    <p className={cssClasses.toggleLabel}>Queue Slot :</p>
                                                </div>
                                                <div style={{ flex: "75%" }}>
                                                    <div>
                                                        <CustomInput value={event?.queueSlot} placeholder={'Enter'} inputType={'number'} handleChange={(e) => { setEvent((pre) => { pre.queueSlot = e; return { ...pre } }) }} />
                                                    </div>
                                                </div>
                                            </div> */}
                      <div className={cssClasses.labelToggleWrapper}>
                        <div style={{ flex: "25%" }}>
                          <p className={cssClasses.toggleLabel}>
                            Attendance Queue:
                          </p>
                        </div>
                        <div style={{ flex: "75%" }}>
                          <CustomAutoComplete
                            disable={false}
                            multiple={true}
                            InitialValue={(e) => {
                              setEvent((pre) => {
                                let arr = [];
                                e.forEach((ele, index) => {
                                  arr.push(
                                    users.filter((e) => {
                                      return e.name === ele;
                                    })[0].userId
                                  );
                                  if (e.length - 1 === index) {
                                    pre.attendanceQueue = arr;
                                  }
                                });
                                return { ...pre };
                              });
                            }}
                            value={users
                              .filter((e) => {
                                return event?.attendanceQueue?.includes(
                                  e.userId
                                );
                              })
                              .map((m) => m.name)}
                            list={users.map((m) => m.name)}
                          />
                        </div>
                      </div>
                      <div className={cssClasses.labelToggleWrapper}>
                        <div style={{ flex: "25%" }}>
                          <p className={cssClasses.toggleLabel}>
                            Reporting Queue:
                          </p>
                        </div>
                        <div style={{ flex: "75%" }}>
                          <CustomAutoComplete
                            disable={false}
                            multiple={true}
                            InitialValue={(e) => {
                              setEvent((pre) => {
                                let arr = [];
                                e.forEach((ele, index) => {
                                  arr.push(
                                    users.filter((e) => {
                                      return e.name === ele;
                                    })[0].userId
                                  );
                                  if (e.length - 1 === index) {
                                    pre.reportingQueue = arr;
                                  }
                                });
                                return { ...pre };
                              });
                            }}
                            value={users
                              .filter((e) => {
                                return event?.reportingQueue?.includes(
                                  e.userId
                                );
                              })
                              .map((m) => m.name)}
                            list={users.map((m) => m.name)}
                          />
                        </div>
                      </div>
                      {/* <div className={cssClasses.labelToggleWrapper}>
                                                <div style={{ flex: "25%" }}>
                                                    <p className={cssClasses.toggleLabel}>Leads:</p>
                                                </div>
                                                <div style={{ flex: "75%" }}>
                                                    <CustomRadio value={event?.leads} onChangeValue={(e) => { setEvent((pre) => { pre.leads = e; return { ...pre } }) }} optionList={['All', 'With Token']} />
                                                </div>
                                            </div> */}
                    </div>
                  </Box>
                </TabPanel>
                <TabPanel
                  className={cssClasses.tabPanel}
                  value={'Live Inventory Display Config'}
                  index={1}
                >
                  <Box className={cssClasses.mainTabPanelWrapper}>
                    <div
                      style={{ paddingBottom: '2rem' }}
                      className={cssClasses.header}
                    >
                      <p className={cssClasses.headerText}>
                        Live Inventory Display Config
                      </p>
                    </div>
                    <TabContext value={tabs.find((f) => f.isSelected)?.value}>
                      <TabsMenu
                        selectedColor={'#1570EF'}
                        selectedBackgroundColor={'#FFFFFF'}
                        stylesForTab={{
                          color: '#344054',
                          fontSize: '1.6rem',
                          fontStyle: 'normal',
                          fontWeight: '500',
                          lineHeight: '2.4rem',
                          // padding: "0.8rem 1.2rem",
                          textTransform: 'unset',
                          borderBottom: '1px solid #EAECF0',
                        }}
                        borderColor={'#1570EFs'}
                        stylesForWrapper={{
                          padding: '1.5rem 0',
                          background: '#FFFFFF',
                        }}
                        list={tabs}
                        value={tabs.find((f) => f.isSelected)?.value}
                        handleChange={(e, value) => {
                          console.log(e, value);

                          setTab((pre) => [
                            ...pre?.map((m) => ({
                              ...m,
                              isSelected: Boolean(m?.value === value),
                            })),
                          ]);
                          tabChange(value);
                        }}
                      />
                      {tabs.map((m, index) => (
                        <TabPanel
                          className={cssClasses.tabPanel}
                          index={index}
                          value={m.value}
                        >
                          <div
                            style={{
                              paddingBottom: '2rem',
                              borderBottom: '1px solid #DADCE0',
                            }}
                          >
                            {launch?.[0]?.unitTypeDisplay?.map((m, i) => {
                              console.log('m ===>', m);
                              return (
                                <div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      gap: '2rem',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '2rem',
                                        alignItems: 'center',
                                      }}
                                    >
                                      {/* <p className={cssClasses.toggleLabel1}>Unit Type:</p> */}
                                      <p
                                        style={{ fontFamily: 'Inter-Medium' }}
                                        className={cssClasses.toggleLabel1}
                                      >
                                        {m.unitType}
                                      </p>
                                    </div>
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '2rem',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <p className={cssClasses.toggleLabel}>
                                        Display:
                                      </p>
                                      <CustomToggle
                                        checked={
                                          launch[0]?.unitTypeDisplay[i].display
                                        }
                                        setChecked={() => {
                                          setLaunch((pre) => {
                                            if (
                                              pre[0].unitTypeDisplay[i].display
                                            ) {
                                              pre[0].unitTypeDisplay[i].color = '';
                                            }
                                            pre[0].unitTypeDisplay[i].display =
                                              !pre[0].unitTypeDisplay[i].display;
                                            return { ...pre };
                                          });
                                        }}
                                      />
                                    </div>

                                    {/* {event?.unitTypeDisplay[i].display &&
                                                            <div style={{
                                                                display: 'flex',
                                                                gap: '2rem',
                                                                alignItems: 'center'
                                                            }}>
                                                                
                                                                <p className={cssClasses.toggleLabel}>Color:</p>
                                                                <MuiColorInput className={classes.inputStyle} value={m.color} onChange={(e) => {
                                                                    setEvent((pre) => {
                                                                        pre.unitTypeDisplay[i].color = e;
                                                                        return { ...pre }
                                                                    })
                                                                }} />
                                                            </div>
                                                        } */}
                                  </div>

                                  <div
                                    style={{
                                      paddingTop: '2rem',
                                      marginLeft: '2rem',
                                    }}
                                  >
                                    {m?.unitStatusDisplay?.map((p, index) => (
                                      <div
                                        style={{
                                          display: 'flex',

                                          gap: '3rem',
                                          marginBottom: '2rem',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '2rem',
                                          }}
                                        >
                                          {/* <p className={cssClasses.toggleLabel}>Unit Status:</p> */}
                                          <p
                                            style={{
                                              fontFamily: 'Inter-Medium',
                                            }}
                                            className={cssClasses.toggleLabel}
                                          >
                                            {p.unitStatus}
                                          </p>
                                        </div>
                                        <div
                                          style={{
                                            display: 'flex',
                                            gap: '2rem',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <p className={cssClasses.toggleLabel}>
                                            Display:
                                          </p>
                                          <CustomToggle
                                            checked={
                                              m?.unitStatusDisplay[index]
                                                .display
                                            }
                                            setChecked={() => {
                                              setLaunch((pre) => {
                                                pre[0].unitTypeDisplay[
                                                  i
                                                ].unitStatusDisplay[
                                                  index
                                                ].display =
                                                  !pre[0].unitTypeDisplay[i]
                                                    .unitStatusDisplay[index]
                                                    .display;
                                                return { ...pre };
                                              });
                                            }}
                                          />
                                        </div>
                                        {m?.unitStatusDisplay[index]
                                          .display && (
                                            <>
                                              <div
                                                style={{
                                                  display: 'flex',
                                                  gap: '2rem',
                                                  alignItems: 'center',
                                                }}
                                              >
                                                <p
                                                  className={
                                                    cssClasses.toggleLabel
                                                  }
                                                >
                                                  Color:
                                                </p>
                                                <MuiColorInput
                                                  className={classes.inputStyle}
                                                  value={p.color}
                                                  onChange={(e) => {
                                                    setLaunch((pre) => {
                                                      pre[0].unitTypeDisplay[
                                                        i
                                                      ].unitStatusDisplay[
                                                        index
                                                      ].color = e;
                                                      return { ...pre };
                                                    });
                                                    console.log(
                                                      'm?.unitStatusDisplay[index].color',
                                                      m?.unitStatusDisplay[index]
                                                        .color
                                                    );
                                                  }}
                                                />
                                              </div>
                                              <div
                                                style={{
                                                  display: 'flex',
                                                  gap: '2rem',
                                                  alignItems: 'center',
                                                }}
                                              >
                                                <p
                                                  className={
                                                    cssClasses.toggleLabel
                                                  }
                                                >
                                                  {' '}
                                                  Text Color:
                                                </p>
                                                <MuiColorInput
                                                  className={classes.inputStyle}
                                                  value={p.textColor}
                                                  onChange={(e) => {
                                                    setLaunch((pre) => {
                                                      pre[0].unitTypeDisplay[
                                                        i
                                                      ].unitStatusDisplay[
                                                        index
                                                      ].textColor = e;
                                                      return { ...pre };
                                                    });
                                                  }}
                                                />
                                              </div>
                                            </>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </TabPanel>
                      ))}
                    </TabContext>
                    {/* <Tabs
                      value={tabValue}
                      onChange={tabChange}
                      variant='scrollable'
                      scrollButtons='auto'
                      aria-label='scrollable auto tabs example'
                      sx={[
                        {
                          borderBottom: '1px solid #EAECF0 !important',
                        },
                      ]}
                    >
                      {tabList}
                      
                    </Tabs> */}

                    {/* <div style={{ paddingTop: "2rem" }}>
                                            {event?.unitStatusDisplay?.map((m, i) => (
                                                <div style={{
                                                    display: 'flex',
                                                    gap: '3rem',
                                                    marginBottom: '2rem',
                                                    alignItems: 'center'
                                                }}>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '2rem'
                                                    }}>
                                                        <p className={cssClasses.toggleLabel}>Unit Status:</p>
                                                        <p style={{ fontFamily: 'Inter-Medium' }} className={cssClasses.toggleLabel}>{m.unitStatus}</p>
                                                    </div>
                                                    <div style={{
                                                        display: 'flex',
                                                        gap: '2rem',
                                                        alignItems: 'center'
                                                    }}>
                                                        <p className={cssClasses.toggleLabel}>Display:</p>
                                                        <CustomToggle checked={event?.unitStatusDisplay[i].display} setChecked={() => { setEvent((pre) => { pre.unitStatusDisplay[i].display = !pre.unitStatusDisplay[i].display; return { ...pre } }) }} />
                                                    </div>
                                                    <div style={{
                                                        display: 'flex',
                                                        gap: '2rem',
                                                        alignItems: 'center'
                                                    }}>
                                                        <p className={cssClasses.toggleLabel}>Color:</p>
                                                        <MuiColorInput className={classes.inputStyle} value={m.color} onChange={(e) => {
                                                            setEvent((pre) => {
                                                                pre.unitStatusDisplay[i].color = e;
                                                                return { ...pre }
                                                            })
                                                        }} />
                                                    </div>

                                                </div>
                                            ))
                                            }
                                        </div> */}
                  </Box>
                </TabPanel>
                <TabPanel
                  className={cssClasses.tabPanel}
                  value={'Payment Config'}
                  index={2}
                >
                  <Box className={cssClasses.mainTabPanelWrapper}>
                    {/* <div>
                                            <div style={{ paddingBottom: "2rem" }} className={cssClasses.header}>
                                                <p className={cssClasses.headerText}>Payment Module Type</p>
                                            </div>
                                            <div className={cssClasses.labelToggleWrapper}>
                                                <div style={{ flex: "25%" }}>
                                                    <p className={cssClasses.toggleLabel}>Sales Manager Desk Payment Module:</p>
                                                </div>
                                                <div style={{ flex: "75%", display: 'flex' }}>
                                                    <div style={{ flex: '0.3' }}>
                                                        <DropDown list={['Sales Manager Desk', 'Separate Desk']} selectedValue={event?.paymentModule} onChangeSelect={(e) => { setEvent((pre) => { pre.paymentModule = e; return { ...pre } }) }} />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ paddingBottom: "2rem" }} className={cssClasses.header}>
                                                <p className={cssClasses.headerText}>Token Payment</p>
                                            </div>
                                            {event?.tokenPayment?.map((m) => (
                                                <div style={{
                                                    display: 'flex',
                                                    gap: '3rem',
                                                    marginBottom: '2rem',
                                                    alignItems: 'center'
                                                }}>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '2rem',
                                                        flex: '30%'
                                                    }}>
                                                        <p className={cssClasses.toggleLabel}>{m.token} Payment Methods:</p>
                                                    </div>
                                                    <div style={{
                                                        display: 'flex',
                                                        gap: '2rem',
                                                        alignItems: 'center',
                                                        flex: '70%'
                                                    }}>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'stretch'
                                                        }}>
                                                            <div>
                                                                <label class={cssClasses.container}>
                                                                    <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                                                        setEvent((pre) => {
                                                                            if (pre.tokenPayment[pre.tokenPayment.findIndex((e) => e.token === m.token)].paymentMethods.includes('Cheque')) {
                                                                                pre.tokenPayment[pre.tokenPayment.findIndex((e) => e.token === m.token)].paymentMethods.splice(pre.tokenPayment[pre.tokenPayment.findIndex((e) => e.token === m.token)].paymentMethods.findIndex((e) => e === 'Cheque'), 1)
                                                                            } else {
                                                                                pre.tokenPayment[pre.tokenPayment.findIndex((e) => e.token === m.token)].paymentMethods.push('Cheque')
                                                                            }
                                                                            return { ...pre }
                                                                        })
                                                                    }} checked={m.paymentMethods.includes('Cheque')} />
                                                                    <span class={cssClasses.checkmark}></span>
                                                                </label>
                                                            </div>
                                                            <p className={cssClasses.toggleLabel}>Cheque</p>
                                                        </div>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'stretch'
                                                        }}>
                                                            <div>
                                                                <label class={cssClasses.container}>
                                                                    <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                                                        setEvent((pre) => {
                                                                            if (pre.tokenPayment[pre.tokenPayment.findIndex((e) => e.token === m.token)].paymentMethods.includes('Card')) {
                                                                                pre.tokenPayment[pre.tokenPayment.findIndex((e) => e.token === m.token)].paymentMethods.splice(pre.tokenPayment[pre.tokenPayment.findIndex((e) => e.token === m.token)].paymentMethods.findIndex((e) => e === 'Card'), 1)
                                                                            } else {
                                                                                pre.tokenPayment[pre.tokenPayment.findIndex((e) => e.token === m.token)].paymentMethods.push('Card')
                                                                            }
                                                                            return { ...pre }
                                                                        })
                                                                    }} checked={m.paymentMethods.includes('Card')} />
                                                                    <span class={cssClasses.checkmark}></span>
                                                                </label>
                                                            </div>
                                                            <p className={cssClasses.toggleLabel}>Card</p>
                                                        </div>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'stretch'
                                                        }}>
                                                            <div>
                                                                <label class={cssClasses.container}>
                                                                    <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                                                        setEvent((pre) => {
                                                                            if (pre.tokenPayment[pre.tokenPayment.findIndex((e) => e.token === m.token)].paymentMethods.includes('Razorpay')) {
                                                                                pre.tokenPayment[pre.tokenPayment.findIndex((e) => e.token === m.token)].paymentMethods.splice(pre.tokenPayment[pre.tokenPayment.findIndex((e) => e.token === m.token)].paymentMethods.findIndex((e) => e === 'Razorpay'), 1)
                                                                            } else {
                                                                                pre.tokenPayment[pre.tokenPayment.findIndex((e) => e.token === m.token)].paymentMethods.push('Razorpay')
                                                                            }
                                                                            return { ...pre }
                                                                        })
                                                                    }} checked={m.paymentMethods.includes('Razorpay')} />
                                                                    <span class={cssClasses.checkmark}></span>
                                                                </label>
                                                            </div>
                                                            <p className={cssClasses.toggleLabel}>Razorpay</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                            }
                                        </div> */}
                    <div>
                      <div style={{ paddingBottom: "2rem" }} className={cssClasses.header}>
                        <p className={cssClasses.headerText}>Allotment Payment</p>
                      </div>
                      <div style={{
                        display: 'flex',
                        gap: '3rem',
                        marginBottom: '5rem',
                        alignItems: 'center'
                      }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '2rem',
                          flex: '30%'
                        }}>
                          <div>
                            <label class={cssClasses.container}>
                              <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                setEvent((pre) => {
                                  pre.salesManagerDeskPaymentModes = pre.salesManagerDeskPaymentModes ? pre.salesManagerDeskPaymentModes : []
                                  if (pre.salesManagerDeskPaymentModes.length > 0) {
                                    pre.salesManagerDeskPaymentModes = []
                                  } else {
                                    pre.salesManagerDeskPaymentModes.push('Virtual Acc')
                                  }
                                  return { ...pre }
                                })
                              }} checked={event?.salesManagerDeskPaymentModes?.length > 0} />
                              <span class={cssClasses.checkmark}></span>
                            </label>
                          </div>
                          <p className={cssClasses.toggleLabel}>Sales Manager Desk Payment Method:</p>
                        </div>
                        <div style={{
                          display: 'flex',
                          gap: '2rem',
                          alignItems: 'center',
                          flex: '70%'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'stretch'
                          }}>
                            <div>
                              <label class={cssClasses.container}>
                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                  setEvent((pre) => {
                                    pre.salesManagerDeskPaymentModes = pre.salesManagerDeskPaymentModes ? pre.salesManagerDeskPaymentModes : []
                                    if (pre.salesManagerDeskPaymentModes.includes('Virtual Acc')) {
                                      pre.salesManagerDeskPaymentModes.splice(pre.salesManagerDeskPaymentModes.findIndex((e) => e === 'Virtual Acc'), 1)
                                      // if (!pre.salesManagerDeskPaymentModes.includes('Cheque') && !pre.salesManagerDeskPaymentModes.includes('Card')) {
                                      //     pre.minOnlineAmt = null
                                      // }
                                    } else {
                                      pre.salesManagerDeskPaymentModes.push('Virtual Acc')
                                      // if (!pre.salesManagerDeskPaymentModes.includes('Razorpay')) {
                                      //     pre.salesManagerDeskPaymentModes.push('Razorpay')
                                      // }
                                    }
                                    return { ...pre }
                                  })
                                }} checked={event?.salesManagerDeskPaymentModes?.includes('Virtual Acc')} />
                                <span class={cssClasses.checkmark}></span>
                              </label>
                            </div>
                            <p className={cssClasses.toggleLabel}>Virtual Acc</p>
                          </div>
                          <div style={{
                            display: 'flex',
                            alignItems: 'stretch'
                          }}>
                            <div>
                              <label class={cssClasses.container}>
                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                  setEvent((pre) => {
                                    pre.salesManagerDeskPaymentModes = pre.salesManagerDeskPaymentModes ? pre.salesManagerDeskPaymentModes : []
                                    if (pre.salesManagerDeskPaymentModes.includes('Card')) {
                                      pre.salesManagerDeskPaymentModes.splice(pre.salesManagerDeskPaymentModes.findIndex((e) => e === 'Card'), 1)
                                      // if (!pre.salesManagerDeskPaymentModes.includes('Cheque') && !pre.salesManagerDeskPaymentModes.includes('Card')) {
                                      //     pre.minOnlineAmt = null
                                      // }
                                    } else {
                                      pre.salesManagerDeskPaymentModes.push('Card')
                                      // if (!pre.salesManagerDeskPaymentModes.includes('Razorpay')) {
                                      //     pre.salesManagerDeskPaymentModes.push('Razorpay')
                                      // }
                                    }
                                    return { ...pre }
                                  })
                                }} checked={event?.salesManagerDeskPaymentModes?.includes('Card')} />
                                <span class={cssClasses.checkmark}></span>
                              </label>
                            </div>
                            <p className={cssClasses.toggleLabel}>Card</p>
                          </div>
                          <div style={{
                            display: 'flex',
                            alignItems: 'stretch'
                          }}>
                            <div>
                              <label class={cssClasses.container}>
                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                  setEvent((pre) => {
                                    pre.salesManagerDeskPaymentModes = pre.salesManagerDeskPaymentModes ? pre.salesManagerDeskPaymentModes : []
                                    if (pre.salesManagerDeskPaymentModes.includes('Razorpay')) {
                                      pre.salesManagerDeskPaymentModes.splice(pre.salesManagerDeskPaymentModes.findIndex((e) => e === 'Razorpay'), 1)
                                    } else {
                                      pre.salesManagerDeskPaymentModes.push('Razorpay')
                                    }
                                    return { ...pre }
                                  })
                                }} checked={event?.salesManagerDeskPaymentModes?.includes('Razorpay')} />
                                <span class={cssClasses.checkmark}></span>
                              </label>
                            </div>
                            <p className={cssClasses.toggleLabel}>Razorpay</p>
                          </div>
                          <div style={{
                            display: 'flex',
                            alignItems: 'stretch'
                          }}>
                            <div>
                              <label class={cssClasses.container}>
                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                  setEvent((pre) => {
                                    pre.salesManagerDeskPaymentModes = pre.salesManagerDeskPaymentModes ? pre.salesManagerDeskPaymentModes : []
                                    if (pre.salesManagerDeskPaymentModes.includes('Cheque')) {
                                      pre.salesManagerDeskPaymentModes.splice(pre.salesManagerDeskPaymentModes.findIndex((e) => e === 'Cheque'), 1)
                                      if (!pre.salesManagerDeskPaymentModes.includes('Cheque') && !pre.salesManagerDeskPaymentModes.includes('Card')) {
                                        pre.minOnlineAmt = 0
                                      }
                                    } else {
                                      pre.salesManagerDeskPaymentModes.push('Cheque')
                                      if (!pre.salesManagerDeskPaymentModes.includes('Razorpay')) {
                                        pre.salesManagerDeskPaymentModes.push('Razorpay')
                                      }
                                    }
                                    return { ...pre }
                                  })
                                }} checked={event?.salesManagerDeskPaymentModes?.includes('Cheque')} />
                                <span class={cssClasses.checkmark}></span>
                              </label>
                            </div>
                            <p className={cssClasses.toggleLabel}>Cheque</p>
                          </div>
                          {(event?.salesManagerDeskPaymentModes?.includes('Cheque')) &&
                            <div>
                              <CustomInput value={event?.minOnlineAmt} inputType={'number'} placeholder={"Enter minimum online payment amount"} handleChange={(e) => {
                                setEvent((pre) => {
                                  pre.minOnlineAmt = e;
                                  return { ...pre }
                                })
                              }} />
                            </div>
                          }
                        </div>
                      </div>
                      <div style={{
                        display: 'flex',
                        gap: '3rem',
                        marginBottom: '5rem',
                        alignItems: 'center'
                      }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '2rem',
                          flex: '30%'
                        }}>
                          <p className={cssClasses.toggleLabel}>Seperate Desk Payment Method:</p>
                        </div>
                        <div style={{
                          display: 'flex',
                          gap: '2rem',
                          alignItems: 'center',
                          flex: '70%'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'stretch'
                          }}>
                            <div>
                              <label class={cssClasses.container}>
                                <input disabled={true} class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                  setEvent((pre) => {
                                    pre.seperateDeskPaymentModes = pre.seperateDeskPaymentModes ? pre.seperateDeskPaymentModes : []
                                    if (pre.seperateDeskPaymentModes.includes('Virtual Acc')) {
                                      pre.seperateDeskPaymentModes.splice(pre.seperateDeskPaymentModes.findIndex((e) => e === 'Virtual Acc'), 1)
                                      // if (!pre.seperateDeskPaymentModes.includes('Cheque') && !pre.seperateDeskPaymentModes.includes('Card')) {
                                      //     pre.minOnlineAmt = null
                                      // }
                                    } else {
                                      pre.seperateDeskPaymentModes.push('Virtual Acc')
                                      // if (!pre.seperateDeskPaymentModes.includes('Razorpay')) {
                                      //     pre.seperateDeskPaymentModes.push('Razorpay')
                                      // }
                                    }
                                    return { ...pre }
                                  })
                                }} checked={event?.seperateDeskPaymentModes?.includes('Virtual Acc')} />
                                <span class={cssClasses.checkmark}></span>
                              </label>
                            </div>
                            <p className={cssClasses.toggleLabel}>Virtual Acc</p>
                          </div>
                          <div style={{
                            display: 'flex',
                            alignItems: 'stretch'
                          }}>
                            <div>
                              <label class={cssClasses.container}>
                                {/* <input disabled={true} class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => { */}
                                {/* ! enabled card checkbox for PKC event on 7th May,2023 because card payments not accepted */}
                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                  setEvent((pre) => {
                                    pre.seperateDeskPaymentModes = pre.seperateDeskPaymentModes ? pre.seperateDeskPaymentModes : []
                                    if (pre.seperateDeskPaymentModes.includes('Card')) {
                                      pre.seperateDeskPaymentModes.splice(pre.seperateDeskPaymentModes.findIndex((e) => e === 'Card'), 1)
                                      // if (!pre.seperateDeskPaymentModes.includes('Cheque') && !pre.seperateDeskPaymentModes.includes('Card')) {
                                      //     pre.minOnlineAmt = null
                                      // }
                                    } else {
                                      pre.seperateDeskPaymentModes.push('Card')
                                      // if (!pre.seperateDeskPaymentModes.includes('Razorpay')) {
                                      //     pre.seperateDeskPaymentModes.push('Razorpay')
                                      // }
                                    }
                                    return { ...pre }
                                  })
                                }} checked={event?.seperateDeskPaymentModes?.includes('Card')} />
                                <span class={cssClasses.checkmark}></span>
                              </label>
                            </div>
                            <p className={cssClasses.toggleLabel}>Card</p>
                          </div>
                          <div style={{
                            display: 'flex',
                            alignItems: 'stretch'
                          }}>
                            <div>
                              <label class={cssClasses.container}>
                                <input disabled={true} class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                  setEvent((pre) => {
                                    pre.seperateDeskPaymentModes = pre.seperateDeskPaymentModes ? pre.seperateDeskPaymentModes : []
                                    if (pre.seperateDeskPaymentModes.includes('Razorpay')) {
                                      pre.seperateDeskPaymentModes.splice(pre.seperateDeskPaymentModes.findIndex((e) => e === 'Razorpay'), 1)
                                    } else {
                                      pre.seperateDeskPaymentModes.push('Razorpay')
                                    }
                                    return { ...pre }
                                  })
                                }} checked={event?.seperateDeskPaymentModes?.includes('Razorpay')} />
                                <span class={cssClasses.checkmark}></span>
                              </label>
                            </div>
                            <p className={cssClasses.toggleLabel}>Razorpay</p>
                          </div>
                          <div style={{
                            display: 'flex',
                            alignItems: 'stretch'
                          }}>
                            <div>
                              <label class={cssClasses.container}>
                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                  setEvent((pre) => {
                                    pre.seperateDeskPaymentModes = pre.seperateDeskPaymentModes ? pre.seperateDeskPaymentModes : []
                                    if (pre.seperateDeskPaymentModes.includes('Cheque')) {
                                      pre.seperateDeskPaymentModes.splice(pre.seperateDeskPaymentModes.findIndex((e) => e === 'Cheque'), 1)
                                      if (!pre.seperateDeskPaymentModes.includes('Cheque') && !pre.seperateDeskPaymentModes.includes('Card')) {
                                        pre.minOnlineAmt = 0
                                      }
                                    } else {
                                      pre.seperateDeskPaymentModes.push('Cheque')
                                      if (!pre.seperateDeskPaymentModes.includes('Razorpay')) {
                                        pre.seperateDeskPaymentModes.push('Razorpay')
                                      }
                                    }
                                    return { ...pre }
                                  })
                                }} checked={event?.seperateDeskPaymentModes?.includes('Cheque')} />
                                <span class={cssClasses.checkmark}></span>
                              </label>
                            </div>
                            <p className={cssClasses.toggleLabel}>Cheque</p>
                          </div>
                          {(event?.seperateDeskPaymentModes?.includes('Cheque')) &&
                            <div>
                              <CustomInput value={event?.minOnlineAmt} inputType={'number'} placeholder={"Enter minimum online payment amount"} handleChange={(e) => {
                                setEvent((pre) => {
                                  pre.minOnlineAmt = e;
                                  return { ...pre }
                                })
                              }} />
                            </div>
                          }
                        </div>
                      </div>
                      <div style={{
                        display: 'flex',
                        gap: '3rem',
                        marginBottom: '2rem',
                        alignItems: 'center'
                      }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '2rem',
                          flex: '30%'
                        }}>
                          {/* <div>
                                                        <label class={cssClasses.container}>
                                                            <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                                                setEvent((pre) => {
                                                                    pre.salesManagerDeskPaymentModes = pre.salesManagerDeskPaymentModes ? pre.salesManagerDeskPaymentModes : []
                                                                    if (pre.salesManagerDeskPaymentModes.length > 0) {
                                                                        pre.salesManagerDeskPaymentModes = []
                                                                    } else {
                                                                        pre.salesManagerDeskPaymentModes.push('Virtual Acc')
                                                                    }
                                                                    return { ...pre }
                                                                })
                                                            }} checked={event?.salesManagerDeskPaymentModes?.length > 0} />
                                                            <span class={cssClasses.checkmark}></span>
                                                        </label>
                                                    </div> */}
                          <p className={cssClasses.toggleLabel}>Preselect Payment Method:</p>
                        </div>
                        <div style={{
                          display: 'flex',
                          gap: '2rem',
                          alignItems: 'center',
                          flex: '70%'
                        }}>
                          {/* <div style={{
                                                        display: 'flex',
                                                        alignItems: 'stretch'
                                                    }}>
                                                        <div>
                                                            <label class={cssClasses.container}>
                                                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                                                    setEvent((pre) => {
                                                                        pre.salesManagerDeskPaymentModes = pre.salesManagerDeskPaymentModes ? pre.salesManagerDeskPaymentModes : []
                                                                        if (pre.salesManagerDeskPaymentModes.includes('Virtual Acc')) {
                                                                            pre.salesManagerDeskPaymentModes.splice(pre.salesManagerDeskPaymentModes.findIndex((e) => e === 'Virtual Acc'), 1)
                                                                            // if (!pre.salesManagerDeskPaymentModes.includes('Cheque') && !pre.salesManagerDeskPaymentModes.includes('Card')) {
                                                                            //     pre.minOnlineAmt = null
                                                                            // }
                                                                        } else {
                                                                            pre.salesManagerDeskPaymentModes.push('Virtual Acc')
                                                                            // if (!pre.salesManagerDeskPaymentModes.includes('Razorpay')) {
                                                                            //     pre.salesManagerDeskPaymentModes.push('Razorpay')
                                                                            // }
                                                                        }
                                                                        return { ...pre }
                                                                    })
                                                                }} checked={event?.salesManagerDeskPaymentModes?.includes('Virtual Acc')} />
                                                                <span class={cssClasses.checkmark}></span>
                                                            </label>
                                                        </div>
                                                        <p className={cssClasses.toggleLabel}>Virtual Acc</p>
                                                    </div> */}
                          <div style={{
                            display: 'flex',
                            alignItems: 'stretch'
                          }}>
                            <div>
                              <label class={cssClasses.container}>
                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                  setEvent((pre) => {
                                    pre.preselectPaymentModes = pre.preselectPaymentModes ? pre.preselectPaymentModes : []
                                    if (pre.preselectPaymentModes.includes('Card')) {
                                      pre.preselectPaymentModes.splice(pre.preselectPaymentModes.findIndex((e) => e === 'Card'), 1)
                                      // if (!pre.preselectPaymentModes.includes('Cheque') && !pre.preselectPaymentModes.includes('Card')) {
                                      //     pre.minOnlineAmt = null
                                      // }
                                    } else {
                                      pre.preselectPaymentModes.push('Card')
                                      // if (!pre.preselectPaymentModes.includes('Razorpay')) {
                                      //     pre.preselectPaymentModes.push('Razorpay')
                                      // }
                                    }
                                    return { ...pre }
                                  })
                                }} checked={event?.preselectPaymentModes?.includes('Card')} />
                                <span class={cssClasses.checkmark}></span>
                              </label>
                            </div>
                            <p className={cssClasses.toggleLabel}>Card</p>
                          </div>
                          <div style={{
                            display: 'flex',
                            alignItems: 'stretch'
                          }}>
                            <div>
                              <label class={cssClasses.container}>
                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                  setEvent((pre) => {
                                    pre.preselectPaymentModes = pre.preselectPaymentModes ? pre.preselectPaymentModes : []
                                    if (pre.preselectPaymentModes.includes('Razorpay')) {
                                      pre.preselectPaymentModes.splice(pre.preselectPaymentModes.findIndex((e) => e === 'Razorpay'), 1)
                                    } else {
                                      pre.preselectPaymentModes.push('Razorpay')
                                    }
                                    return { ...pre }
                                  })
                                }} checked={event?.preselectPaymentModes?.includes('Razorpay')} />
                                <span class={cssClasses.checkmark}></span>
                              </label>
                            </div>
                            <p className={cssClasses.toggleLabel}>Razorpay</p>
                          </div>
                          <div style={{
                            display: 'flex',
                            alignItems: 'stretch'
                          }}>
                            <div>
                              <label class={cssClasses.container}>
                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                  setEvent((pre) => {
                                    pre.preselectPaymentModes = pre.preselectPaymentModes ? pre.preselectPaymentModes : []
                                    if (pre.preselectPaymentModes.includes('Customer In-App')) {
                                      pre.preselectPaymentModes.splice(pre.preselectPaymentModes.findIndex((e) => e === 'Customer In-App'), 1)
                                    } else {
                                      pre.preselectPaymentModes.push('Customer In-App')
                                    }
                                    return { ...pre }
                                  })
                                }} checked={event?.preselectPaymentModes?.includes('Customer In-App')} />
                                <span class={cssClasses.checkmark}></span>
                              </label>
                            </div>
                            <p className={cssClasses.toggleLabel}>Customer In-App</p>
                          </div>
                          {/* <div style={{
                                                        display: 'flex',
                                                        alignItems: 'stretch'
                                                    }}>
                                                        <div>
                                                            <label class={cssClasses.container}>
                                                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={(e) => {
                                                                    setEvent((pre) => {
                                                                        pre.salesManagerDeskPaymentModes = pre.salesManagerDeskPaymentModes ? pre.salesManagerDeskPaymentModes : []
                                                                        if (pre.salesManagerDeskPaymentModes.includes('Card')) {
                                                                            pre.salesManagerDeskPaymentModes.splice(pre.salesManagerDeskPaymentModes.findIndex((e) => e === 'Card'), 1)
                                                                            // if (!pre.salesManagerDeskPaymentModes.includes('Cheque') && !pre.salesManagerDeskPaymentModes.includes('Card')) {
                                                                            //     pre.minOnlineAmt = null
                                                                            // }
                                                                        } else {
                                                                            pre.salesManagerDeskPaymentModes.push('Card')
                                                                            // if (!pre.salesManagerDeskPaymentModes.includes('Razorpay')) {
                                                                            //     pre.salesManagerDeskPaymentModes.push('Razorpay')
                                                                            // }
                                                                        }
                                                                        return { ...pre }
                                                                    })
                                                                }} checked={event?.salesManagerDeskPaymentModes?.includes('Card')} />
                                                                <span class={cssClasses.checkmark}></span>
                                                            </label>
                                                        </div>
                                                        <p className={cssClasses.toggleLabel}>Cheque</p>
                                                    </div> */}
                          {event?.preselectPaymentModes?.includes(
                            "Cheque"
                          ) && (
                              <div>
                                <CustomInput
                                  value={event?.minOnlineAmt}
                                  inputType={"number"}
                                  placeholder={
                                    "Enter minimum online payment amount"
                                  }
                                  handleChange={(e) => {
                                    setEvent((pre) => {
                                      pre.minOnlineAmt = e;
                                      return { ...pre };
                                    });
                                  }}
                                />
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </Box>
                </TabPanel>
                <TabPanel
                  className={cssClasses.tabPanel}
                  value={"Preselect Config"}
                  index={3}
                >
                  <Box>
                    <TabContext
                      value={
                        tokenSubTabs
                          ?.filter((val) => val !== null)
                          .find((f) => f?.isSelected)?.value
                      }
                    >
                      <TabsMenu
                        selectedColor={"#1570EF"}
                        selectedBackgroundColor={"#FFFFFF"}
                        stylesForTab={{
                          color: "#344054",
                          fontSize: "1.6rem",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "2.4rem",
                          padding: "0.8rem 1.2rem",
                          textTransform: "unset",
                          borderBottom: "1px solid #EAECF0",
                        }}
                        borderColor={"#1570EFs"}
                        stylesForWrapper={{
                          padding: "1.5rem 0",
                          background: "#FFFFFF",
                        }}
                        list={tokenSubTabs?.filter((val) => val !== null)}
                        value={
                          tokenSubTabs
                            ?.filter((val) => val !== null)
                            .find((f) => f?.isSelected)?.value
                        }
                        handleChange={(e, value) => {
                          setTokenSubTabs((pre) => {
                            pre.forEach((ele) => {
                              if (ele.value === value) {
                                ele.isSelected = true;
                              } else {
                                ele.isSelected = false;
                              }
                            });
                            return [...pre];
                          });
                        }}
                      />
                      {launchWiseToken?.map((val, ind) => {
                        return (val?.token?.length > 0 &&
                          <TabPanel
                            style={{
                              height: "calc(100% - 7rem)",
                              padding: "0rem 0rem 2rem 1rem !important",
                            }}
                            className={classes.Tabs}
                            value={val?.title}
                            index={ind}
                          >
                            <PreselectConfig eventTokens={val} index={ind} setEventTokens={setLaunchWiseToken} launchWiseToken={launchWiseToken} />
                          </TabPanel>
                        );
                      })}
                    </TabContext>
                  </Box>
                </TabPanel>
                <TabPanel
                  className={cssClasses.tabPanel}
                  value={"Site Visit Config"}
                  index={4}
                >
                  <Box className={cssClasses.mainTabPanelWrapper}>
                    <div className={cssClasses.header}>
                      <p className={cssClasses.headerText}>Check Site Visit</p>
                    </div>
                    <div className={cssClasses.content}>
                      <div className={cssClasses.labelToggleWrapper}>
                        <div style={{ flex: '25%' }}>
                          <p className={cssClasses.toggleLabel}>
                            Site Visit Start Date:
                          </p>
                        </div>
                        <div
                          style={{
                            flex: '75%',
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            gap: '5rem',
                          }}
                        >
                          <CustomToggle
                            checked={event?.eventSiteVisit}
                            setChecked={() => {
                              setEvent((pre) => {
                                if (pre.eventSiteVisit === true) {
                                  pre.eventSiteVisitDateTime = null;
                                  pre.eventSiteVisit = false;
                                } else {
                                  pre.eventSiteVisit = true;
                                }
                                return { ...pre };
                              });
                            }}
                          />
                          {event?.eventSiteVisit && (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '2rem',
                              }}
                            >
                              <p className={cssClasses.toggleLabel}>
                                Date & Time:
                              </p>
                              <DateComponent
                                helperText={''}
                                value={event?.eventSiteVisitDateTime}
                                minDate={"1 Jan 2024"}
                                onChangeDate={(e) => {
                                  setEvent((pre) => {
                                    pre.eventSiteVisitDateTime = new Date(
                                      e
                                    ).getTime();
                                    return { ...pre };
                                  });
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className={cssClasses.labelToggleWrapper}>
                        <div style={{ flex: '25%' }}>
                          <p className={cssClasses.toggleLabel}>
                            Projects:
                          </p>
                        </div>
                        <div style={{ flex: '75%' }}>
                          <CustomToggle
                            checked={event?.checkProject}
                            setChecked={() => {
                              setEvent((pre) => {
                                pre.checkProject =
                                  !pre.checkProject;
                                return { ...pre };
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </Box>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        </div>
      </div>
      <div className={cssClasses.footer}>
        <div
          className={cssClasses.btnWrapper}
          style={{ marginBottom: '1.6rem' }}
        >
          {eventSettings.timeline[0].isSelected !== true && (
            <Button
              clicked={() => {
                setEventSettings((pre) => {
                  let index = eventSettings.timeline.findIndex(
                    (e) => e.isSelected === true
                  );
                  pre.timeline[index].isSelected = false;
                  pre.timeline[index - 1].isSelected = true;
                  searchParams.set(
                    "submenu",
                    eventSettings.timeline[index - 1].value
                  );
                  setSearchParams(searchParams);
                  return { ...pre };
                });
              }}
              btnName={"Back Step"}
              style={{
                borderRadius: "0.4rem",
                backgroundColor: "#D0D5DD",
                color: "#FFFFFF",
                fontSize: "1.6rem",
              }}
              padding={"0.5rem 1rem"}
              iconPosition={"left"}
            />
          )}
        </div>
        <div
          className={cssClasses.btnWrapper}
          style={{ marginBottom: "1.6rem" }}
        >
          <Button
            clicked={nextStep}
            btnName={"Save & Next Step"}
            style={{
              borderRadius: "0.4rem",
              backgroundColor: "#1570EF",
              color: "#FFFFFF",
              fontSize: "1.6rem",
            }}
            padding={"0.5rem 1rem"}
            disable={eventSettings?.timeline?.findIndex((e) => e.isSelected === true) === 3 && isBtnDisabled}
            iconPosition={"left"}
          />
        </div>
      </div>
      {openAlert && (
        <ConfirmationAlert
          confirm={(e) => {
            ModalResp(e);
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Continue"}
          close={() => setOpenAlert(false)}
          title={"Warning"}
          subTitle={"Unsaved Changes! Do you want to continue without saving"}
          open={openAlert}
        />
      )}
    </div>
  );
}
